// extracted by mini-css-extract-plugin
export default {"showcase":"style_showcase__yMniM","showcase-fullscreen":"style_showcase-fullscreen__29Ig5","message-overlay":"style_message-overlay__w8KjK"};